import React from 'react';
import ReactDOM from 'react-dom';

import { AppComponent } from './App';
import { SessionContextProvider } from './context/session.context';
import { ProductsContextProvider } from './context/products.context';
import reportWebVitals from './reportWebVitals';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <SessionContextProvider>
      <ProductsContextProvider>
        <AppComponent />
      </ProductsContextProvider>
    </SessionContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
